export default __webpack_public_path__ + "static/media/icons8-external-link-96.132117e5.svg";